import { cva, type VariantProps } from "class-variance-authority";

/** Единая высота/отступы для всех контролов (Button, Input, Select, SearchSelect).
 *  Figma: small = 36px / 14px / иконка 20; normal (md) = 48px / 16px / иконка 24. lg/xl — крупные POS/KDS-кнопки. */
export const controlSize = cva("", {
  variants: {
    size: {
      sm: "h-9 px-4 text-sm leading-[1.4] gap-2 [&_svg]:size-5",
      md: "h-12 px-4 text-base leading-normal gap-2.5 [&_svg]:size-6",
      lg: "h-14 px-6 text-base leading-normal gap-2.5 [&_svg]:size-6",
      xl: "h-16 px-7 text-lg leading-normal gap-3 [&_svg]:size-6",
    },
  },
  defaultVariants: { size: "md" },
});
export type ControlSize = NonNullable<VariantProps<typeof controlSize>["size"]>;

/** Оболочка поля ввода: рамка, фокус, ошибка, disabled. */
export const fieldShell =
  "flex w-full min-w-0 items-center rounded-control border border-border bg-surface text-fg transition-[border-color,box-shadow] " +
  "focus-within:border-primary focus-within:shadow-[var(--shadow-focus)] " +
  "data-[invalid=true]:border-danger " +
  "data-[disabled=true]:cursor-not-allowed data-[disabled=true]:border-transparent data-[disabled=true]:bg-disabled data-[disabled=true]:text-disabled-fg";
